import { Check, Minus } from "lucide-react";
import { Reveal } from "./Reveal";
import { BuyButton } from "./BuyButton";

const HIRE = [
  "Civility Partners facilitates the session for you",
  "Two-hour Building a Speak-Up Culture™ training",
  "Delivered by our expert facilitation team",
  "Scheduled around our availability",
  "Priced per engagement",
];

const OWN = [
  "The same program, slides, and materials we use",
  "White-label — add your logo and brand voice",
  "Customize for any audience or industry",
  "Deliver it yourself, on your schedule",
  "Reuse it unlimited times, forever",
  "Expert video coaching from our facilitators included",
];

export const ValueCompare = () => (
  <section id="value" className="bg-navy py-24 text-cream lg:py-32" data-testid="value-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-terra">The math is simple</p>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
          Same program. Same materials. You hold the clicker.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Reveal>
          <div className="h-full rounded-3xl border border-white/15 p-10 lg:p-12" data-testid="value-card-hire">
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-cream/60">Hire Civility Partners</p>
            <p className="mt-4 font-display text-5xl font-extrabold tracking-tight text-cream/80 lg:text-6xl">$10,000</p>
            <p className="mt-2 text-sm text-cream/50">per delivered training engagement</p>
            <ul className="mt-10 space-y-4">
              {HIRE.map((item) => (
                <li key={item} className="flex items-start gap-3 text-cream/70">
                  <Minus className="mt-1 h-4 w-4 shrink-0 text-cream/40" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="relative h-full rounded-3xl border border-terra bg-white/[0.04] p-10 shadow-[0_0_80px_-20px_rgba(224,109,83,0.4)] lg:p-12" data-testid="value-card-own">
            <span className="absolute -top-3.5 left-10 rounded-full bg-terra px-4 py-1.5 text-xs font-bold uppercase tracking-[0.15em] text-cream">
              Best value
            </span>
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-terra">Own the Toolkit</p>
            <p className="mt-4 font-display text-5xl font-extrabold tracking-tight text-cream lg:text-6xl">$249</p>
            <p className="mt-2 text-sm text-cream/50">one-time purchase — 97.5% less</p>
            <ul className="mt-10 space-y-4">
              {OWN.map((item) => (
                <li key={item} className="flex items-start gap-3 text-cream/85">
                  <Check className="mt-1 h-4 w-4 shrink-0 text-terra" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <BuyButton testId="value-buy-button" className="mt-10 w-full sm:w-auto">Own It for $249</BuyButton>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
